/* The fixed vocabularies. Mirrors api/app/taxonomy.py — change both together.

   Categories are a closed list on purpose: new ones are added by hand when a
   member asks, so "ai", "AI/ML" and "genai" never split the people who should
   be finding each other. */

export const CATEGORIES = [
  'web3', 'ai', 'fintech', 'payments', 'infrastructure', 'security',
  'devtools', 'marketplaces', 'talent', 'data', 'agents', 'climate',
];

export const STAGES = ['idea', 'pre-seed', 'seed', 'series-a', 'growth'];

export const ROLES = ['founder', 'operator', 'advisor', 'investor', 'service provider'];

/* Stage means a founder's own company. Anyone who works *with* companies
   describes the stages they serve instead. */
export function isFounder(roles) {
  return (roles || []).includes('founder');
}
export function servesCompanies(roles) {
  return (roles || []).some((r) => r !== 'founder' && ROLES.includes(r));
}

export function toggle(list, value) {
  const current = list || [];
  return current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
}
